import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import core from '@groovepages/gd-lib/core-store';
import records from '@groovepages/gd-lib/records-store';
import domains from '@groovepages/gd-lib/domain-store';
import subdomains from '@groovepages/gd-lib/subdomains-store';

Vue.use(Vuex);

Vue.mixin({
    computed: {
        ...mapState(['lang'])
    }
});

export default new Vuex.Store({
    ...core,
    modules: {
        records,
        domains,
        subdomains,
    },
    getters: {
        user: state => state.user,
        isLiteUser: state => {
            return state.user.roles && state.user.roles.indexOf('groovepages_user') === -1;
        },
        /*
         Check if current user is allowed for testing new features
        */
        canUseNewFeature: (state) => {
          return false;
          const allowedUsers = [
            '5f0d5d4a6ca1bd0016c5142f', // Pankaj's account id
            '5eac3802b05c940cb33d49b7' // David's account id
          ];
          return state && state.user && state.user.id ? allowedUsers.includes(state.user.id) : false;
        },
    },
});